import { object } from "prop-types";
import { TransactionStatus, IOMode, IOType } from "./types";

export function formatIOforUpdate(originalIO) {
  // copy item header to items in withdrawals and deposit
  let io = { ...originalIO };

  io.items = io.items.map((item) => {
    // add IOType for item
    item.IOType = io.IOType;
    // copy header props to item
    const {
      Denominations,
      Quantity,
      CurrencyId,
      CurrencyISO,
      AssetId,
      AssetTicker,
      Correlative,
      IsCurrency,
      Price,
    } = item;
    item = Object.assign({}, io.itemsHeader, {
      Id: io.Id,
      Correlative,
      Quantity,
      Denominations,
      CurrencyId,
      CurrencyISO,
      AssetId,
      AssetTicker,
      Price: io.itemsHeader.Price,
    });

    // Transfers allow currencies mixed with assets, require use item attribute IsCurrency
    if (io.IOType == IOType.Transfer) {
      item.IsCurrency = IsCurrency;
      item.Price = Price;
    }

    return item;
  });

  // remove redundant property
  delete io.itemsHeader;

  return io;
}

export const getNextIOStatus = ({ io, column, action }) => {
  let nextStatus;

  // Is from trader desk move io throw columns
  if (column) {
    switch (column) {
      case "todo":
        nextStatus = TransactionStatus.ROUTED;
        break;

      case "working":
        nextStatus = TransactionStatus.ACKED;
        break;

      case "completed":
        nextStatus = TransactionStatus.FILLED;
        break;
    }
  } else {
    switch (action) {
      case "ack":
        nextStatus = TransactionStatus.ACKED;
        break;
      case "cancel":
        nextStatus = TransactionStatus.CANCELED;
        break;
    }
  }
  return nextStatus;
};
